// extracted by mini-css-extract-plugin
module.exports = {"dragHandle":"src-containers-Form-SimplifiedBuilder-Internal-DragHandle___dragHandle","dragHandleIcon":"src-containers-Form-SimplifiedBuilder-Internal-DragHandle___dragHandleIcon"};